var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38.2134,
    height: 38.2134,
    rx: 8.49186,
    fill: "#D6B981",
    fillOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.976 21.9436C20.2392 21.9436 23.0283 22.4381 23.0283 24.4133C23.0283 26.3886 20.2578 26.8972 16.976 26.8972C13.712 26.8972 10.9238 26.4071 10.9238 24.431C10.9238 22.4549 13.6934 21.9436 16.976 21.9436Z",
    fill: "#D6B981",
    stroke: "#D6B981",
    strokeWidth: 1.59222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9764 19.1242C14.834 19.1242 13.0967 17.3878 13.0967 15.2454C13.0967 13.103 14.834 11.3666 16.9764 11.3666C19.1179 11.3666 20.8552 13.103 20.8552 15.2454C20.8632 17.3799 19.1383 19.1163 17.0038 19.1242H16.9764Z",
    fill: "#D6B981",
    stroke: "#D6B981",
    strokeWidth: 1.59222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0723 18.1175C24.4885 17.9185 25.5791 16.7031 25.5818 15.2321C25.5818 13.7823 24.5247 12.5793 23.1386 12.3519",
    stroke: "#D6B981",
    strokeWidth: 1.59222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9404 21.5238C26.3124 21.7281 27.2704 22.2093 27.2704 23.2001C27.2704 23.8821 26.8193 24.3243 26.0904 24.6012",
    stroke: "#D6B981",
    strokeWidth: 1.59222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.484b1c33bd184fbf84317f19b2be43fb.svg";
export { ForwardRef as ReactComponent };